/**
 * ProjectImageSelector Component
 * 
 * Image selector interface for projects.
 * Displays Firebase image gallery and allows selecting images with descriptions.
 * 
 * Features:
 * - Display gallery of uploaded images
 * - Select images to add to project
 * - Upload new images
 * - Real-time loading from Firebase
 */

import React, { useCallback, useState } from 'react';
import ImageGallery from '../../Common/Images/ImageGallery';

const ProjectImageSelector = ({ userId, onAddImage, disabled }) => {
  const [showGallery, setShowGallery] = useState(false);

  /**
   * Handle image selection from the existing gallery
   * Extracts imageId and prepares for project use
   * 
   * ImageGallery passes the selected saved image so its description can seed
   * the editable project-image description.
   */
  const handleAddImageToProject = useCallback((selectedImage) => {
    const imageItem = {
      imageId: selectedImage.id,
      description: selectedImage.description || '',
    };
    
    onAddImage(imageItem);
    setShowGallery(false);
  }, [onAddImage]);

  return (
    <div className="project-image-selector">
      <div className="d-flex gap-2 mb-3">
        <button
          type="button"
          className="btn btn-primary flex-grow-1"
          onClick={() => setShowGallery((isVisible) => !isVisible)}
          disabled={disabled}
        >
          <i className={`bi ${showGallery ? 'bi-x-lg' : 'bi-plus-lg'} me-2`}></i>
          {showGallery ? 'Close Gallery' : 'Add Images from Gallery'}
        </button>
      </div>

      {/* Use existing ImageGallery component */}
      {showGallery && (
        <div className="mb-3">
          <ImageGallery
            userId={userId}
            setShowGallery={setShowGallery}
            onSelectImage={handleAddImageToProject}
          />
        </div>
      )}
    </div>
  );
};

export default ProjectImageSelector;
